// The one breakpoint, read from the token so CSS and JS cannot disagree.
let cached: number | undefined;
export function deskMin(): number {
  cached ??= parseInt(getComputedStyle(document.documentElement).getPropertyValue('--desk-min'), 10) || 880;
  return cached;
}
/** True on a desk: the contained window, a centred dialog instead of a sheet. */
export const isDesk = (): boolean => matchMedia(`(min-width: ${deskMin()}px)`).matches;
export const reducedMotion = (): boolean => matchMedia('(prefers-reduced-motion: reduce)').matches;
